var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_95",
    "data-name": "Group 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.563,
    height: 19.769,
    viewBox: "0 0 25.563 19.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "filtler-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 25.563,
    height: 19.769,
    fill: "#e761a0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    clipPath: "url(#filtler-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M1.182,5.8H13.994a1.2,1.2,0,1,1,0,2.39H1.182a1.2,1.2,0,0,1,0-2.39m0-5.8H24.308a1.2,1.2,0,1,1,0,2.39H1.182a1.2,1.2,0,0,1,0-2.39m0,11.6h7.9a1.2,1.2,0,0,1,1.209,1.182,1.181,1.181,0,0,1-1.209,1.182h-7.9A1.175,1.175,0,0,1,0,12.785,1.192,1.192,0,0,1,1.182,11.6m0,5.8H6.527a1.182,1.182,0,0,1,0,2.364H1.182a1.182,1.182,0,0,1,0-2.364",
    fill: "#e761a0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M232.233,97.595v8.676l2.74-2.767a1.216,1.216,0,0,1,1.719,1.719l-4.754,4.754h-.027V110h-.027v.027h-.054v.027H231.8v.027h-.027v.027h-.027l-.027.027H231.7v.027h-.027l-.027.027h-.027v.027h-.054v.027h-.054v.027h-.054l-.027.027h-.054l-.027.027h-.107v.027h-.43v-.027H230.7l-.027-.027h-.054l-.027-.027h-.054v-.027h-.054v-.027h-.054v-.027h-.027l-.027-.027h-.027v-.027h-.027l-.027-.027h-.027v-.027c-.054-.027-.107-.081-.161-.107l-4.754-4.754a1.216,1.216,0,0,1,1.719-1.719l2.74,2.767V97.595a1.209,1.209,0,1,1,2.417,0",
    transform: "translate(-211.471 -90.584)",
    fill: "#e761a0",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltler);
export default __webpack_public_path__ + "static/media/filtler.370af87fe11468369ae8a8474bc7e602.svg";
export { ForwardRef as ReactComponent };